import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { get, isUndefined } from 'lodash';
import {
    Avatar, Card, notification, Table, Tag, Switch,
} from 'antd';
import { IBusiness } from '../../../types/bussiness';
import { getProvidersByCoordinates } from '../../../api/deliveryProviders';
import { updateDeliveryProviderBusinessStatus } from '../../../api/business';

const BusinessProviders = ({ userBusiness }: { userBusiness: IBusiness }) => {
    const [loading, setLoading] = useState(false);
    const [deliveryProviders, setDeliveryProviders] = useState<any>([]);
    const { deliveries } = useSelector((state: any) => state.deliveries);

    useEffect(() => {
        setLoading(true);
        getProvidersByCoordinates([
            userBusiness.businessID.longitude.toString(),
            userBusiness.businessID.latitude.toString(),
        ])
            .then(({ data }: any) => {
                const deliveryProviders = data.data;
                const businessDeliveries = get(userBusiness.externalAPIConfiguration, 'deliveryProviders') || [];

                const deliveriesByName: any = businessDeliveries.reduce((accDeliveries, delivery) => ({
                    ...accDeliveries,
                    [delivery.keyName || delivery.name]: delivery,
                }), {});

                const providers = deliveryProviders.reduce(
                    (accDeliveries: any, deliveryKeyName: string) => {
                        const delivery = deliveries.find((d: any) => d.keyName === deliveryKeyName) || {};
                        const isVisible = isUndefined(delivery.isVisible) || delivery.isVisible;
                        const isActive = deliveriesByName[delivery.keyName]?.isActive || deliveriesByName[delivery.name]?.isActive;

                        if (!isVisible && !isActive) return accDeliveries;
                        return [
                            ...accDeliveries,
                            {
                                ...delivery,
                                ...(deliveriesByName[delivery.keyName] || deliveriesByName[delivery.name]),
                                name: delivery.name,
                                isActive,
                            },
                        ];
                    },
                    [],
                );
                setDeliveryProviders(providers);
            })
            .catch((error: any) => {
                console.log({ error });
                const message = get(error, 'response.data.message');
                notification.error({ message });
            })
            .finally(() => setLoading(false));
    }, []);

    const handleDeliveryChange = async (deliveryKey: string, status: boolean) => {
        try {
            setLoading(true);
            const { data } = await updateDeliveryProviderBusinessStatus(userBusiness._id, deliveryKey, status);
            const deliveryUpdated = data.data;
            const deliveryProvidersUpdated = deliveryProviders.map((delivery: any) => {
                if (delivery.keyName === deliveryKey) {
                    return {
                        ...delivery,
                        isActive: deliveryUpdated.isActive,
                        storeStatus: deliveryUpdated.storeStatus,
                    };
                }
                return delivery;
            });
            setDeliveryProviders(deliveryProvidersUpdated);
        } catch (error) {
            console.log(error);
            const message = get(error, 'response.data.message');
            notification.error({ message });
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: '',
            dataIndex: 'image',
            key: 'image',
            width: 50,
            render: (image: string) => <Avatar src={image} />,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (name: string, delivery: any) => (
                <>
                    {name}
                    {delivery.storeStatus === 'Rejected' && (
                        <Tag color="red" style={{ marginLeft: 10 }}>
                            Rejected
                        </Tag>
                    )}
                    {delivery.storeStatus === 'PENDING' && (
                        <Tag color="orange" style={{ marginLeft: 10 }}>
                            Pending
                        </Tag>
                    )}
                    {delivery.storeStatus === 'Approved' && (
                        <Tag color="green" style={{ marginLeft: 10 }}>
                            Accepted
                        </Tag>
                    )}
                </>
            ),
        },
        {
            title: 'isActive',
            dataIndex: 'isActive',
            key: 'isActive',
            render: (isActive: boolean, delivery: any) => (
                <Switch
                    loading={loading}
                    checked={isActive}
                    onChange={(status) => handleDeliveryChange(delivery.keyName, status)}
                    style={{ backgroundColor: delivery.storeStatus === 'PENDING' ? 'orange' : '' }}
                />
            ),
        },

    ];

    return (
        <Card title="Providers">
            <Table
                columns={columns}
                dataSource={deliveryProviders}
                rowKey="_id"
                pagination={false}
            />
        </Card>
    );
};

export default BusinessProviders;
